import React from 'react';
const facts = [{
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '300',
  label: 'Print-ready pages'
}, {
  value: '71',
  label: 'Session plans, word for word'
}, {
  value: '69',
  label: 'Printable worksheets'
}];

// Bandas de color por bloque, como en los tomos (ámbar / verde / coral / papel)
const accents = ['before:bg-gold', 'before:bg-green', 'before:bg-crimson', 'before:bg-ice'];
export function SocialProofBar() {
  return <section className="w-full bg-navy" data-id="element-232" data-mp="32h0h4951z22w">
      <div className="max-w-6xl mx-auto px-5 pt-10 pb-14 sm:pb-16" data-id="element-233" data-mp="2xjrzqarqb22p">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-navy-line bg-navy-line sm:grid-cols-4" data-id="element-234" data-mp="2tiespxcwgsu7">
          {facts.map((fact, i) => <div key={fact.label} className={`relative bg-navy px-4 py-5 text-center before:absolute before:inset-x-0 before:top-0 before:h-1 before:content-[''] ${accents[i]}`} data-id="element-235" data-mp="2oitwvvt110lp" data-mpi={i}>
              <div className="font-display text-3xl sm:text-4xl leading-none text-gold" data-id="element-236" data-mp="1d6j963t53uo4">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-white/60" data-id="element-237" data-mp="1dnnrr37vhm4e">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}